var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classProp},[_c('div',{staticClass:"container  h-100"},[_c('div',{staticClass:"row align-items-end  h-100"},[_c('div',{staticClass:"col-sm "},[_c('h1',{staticClass:"align-bottom"},[_vm._v(_vm._s(_vm.title))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }